import css from "./Form.module.css";
import InfoIcon from "../../Assets/svg/info.svg"; // adjust path to your asset

const FormLabel = ({ id, label, required, infoImage }) => {
  if (!label) return null;

  return (
    <label htmlFor={id} >
      <span className={css.LabelText}>
        {label}
        {required && <span className={css.Required}>*</span>}
      </span>

      {infoImage && (
        <span className={css.InfoWrapper}>
          <img src={InfoIcon} alt="info" className={css.InfoIcon} />
          <div className={css.Tooltip}>
            <img src={infoImage} alt="info preview" />
          </div>
        </span>
      )}
    </label>
  );
};

export default FormLabel;
